//
//
//
//
//
//

export default {
  name: 'Scrolly',
  props: {
    anchor: String,
    cor: String,
  },
}
